import BanIcon from "components/Icons/BanIcon";
import CheckIcon from "components/Icons/CheckIcon";
import EditIcon from "components/Icons/EditIcon";
import ViewIcon from "components/Icons/ViewIcon";
import { Link } from "react-router-dom";
import { RouteName } from "constants/route";
import { IFleetModel } from "models/fleetModel";
import { useFleetModelAlertContext } from "./FleetModelAlertContext";
import DeleteIcon from "components/Icons/DeleteIcon";

interface IProps {
  fleetModel: IFleetModel;
}

export default function Action({ fleetModel }: IProps) {
  const { showActivate, showBan, showDelete } = useFleetModelAlertContext();

  const handleClick = () => {
    if (fleetModel.is_active) showBan(fleetModel);
    else showActivate(fleetModel);
  };
  const handleDelete = () => showDelete(fleetModel);

  return (
    <div className="flex items-center gap-x-3">
      <Link
        to={RouteName.FLEET_MODEL_DETAIL.replace(":id", fleetModel.id)}
        className="rounded-ful hover:text-black"
      >
        <ViewIcon />
      </Link>
      <Link
        to={RouteName.EDIT_FLEET_MODEL.replace(":id", fleetModel.id)}
        className="rounded-ful hover:text-black"
      >
        <EditIcon />
      </Link>
      <button onClick={handleClick} className="rounded-ful">
        {!fleetModel.is_active ? <CheckIcon /> : <BanIcon />}
      </button>
      <button onClick={handleDelete} className="rounded-ful">
        <DeleteIcon />
      </button>
    </div>
  );
}
